import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { makeStyles, styled } from '@material-ui/core/styles';
import PhoneInTalkRoundedIcon from '@material-ui/icons/PhoneInTalkRounded';
import SaveButton from 'UI/components/atoms/SaveButton';

const ICON_SIZE = 56;

export const ListItemOption = styled(ListItem)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.customColors.white,
  minHeight: theme.spacing(6),
  '&.Mui-selected': {
    backgroundColor: theme.palette.customColors.linkWater,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      backgroundColor: theme.palette.customColors.lightButtonHover
    }
  }
}));

export const ListItemIconOption = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.customColors.black,
  marginRight: theme.spacing(2),
  minWidth: theme.spacing(3)
}));

export const FullWidthFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',
  margin: theme.spacing(3, 0, 0, 0),
  width: '100%'
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0)
}));

export const ListStyled = styled('ul')(({ theme }) => ({
  color: theme.palette.text.secondary,
  margin: 0,
  paddingLeft: theme.spacing(2),
  '& li + li': {
    marginTop: theme.spacing(3)
  }
}));

export const CallIconAvatar = styled(PhoneInTalkRoundedIcon)(() => ({
  height: ICON_SIZE,
  width: ICON_SIZE
}));

export const AvatarStyled = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.customColors.lightPurple,
  color: theme.palette.primary.main,
  height: 'fit-content',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(4),
  width: 'fit-content'
}));

export const SaveButtonStyled = styled(SaveButton)({
  maxWidth: 'unset'
});

export const AIProfileListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1.5),
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.04)',
  marginTop: theme.spacing(2),
  padding: theme.spacing(2)
}));

export const AIProfileAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  color: theme.palette.grey[600]
}));

export const useRoleplayScenarioSelectorStyles = makeStyles({
  mainContainer: {
    height: '100%',
    overflow: ({ isCallRinging }) => (isCallRinging ? 'hidden' : 'visible'),
    position: 'relative'
  },
  content: {
    display: ({ isCallRinging }) => (isCallRinging ? 'none' : 'block')
  }
});
